import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const useQuery = () => {
    const location = useLocation();
    const [search, setSearch] = useState(new URLSearchParams());

    useEffect(() => {
        setSearch(new URLSearchParams(location.search))
    }, [location])
    
    return search;
}
